import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=54db8ed6&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=54db8ed6&prod&scoped=true&lang=css"
import style1 from "./layout.vue?vue&type=style&index=1&id=54db8ed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db8ed6",
  null
  
)

export default component.exports